import { Pipe, PipeTransform } from '@angular/core';
import {betragToString} from "../common/utils";

@Pipe({
  name: 'preis'
})
export class PreisPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return betragToString(value);
  }
}

@Pipe({
  name: 'preis2'
})
export class Preis2Pipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value == null) {
      return null;
    }
    return Number.parseFloat(value).toFixed(2).replace('.', ',') + ' €';
  }
}
